<template>
  <page-wrap>
    <layout :isEmpty="false" :messageEmpty="L10n('select-a-part')">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <tools-panel
          :rfq2ID.sync="rfq2ID"
          @update:rfq2ID="handlerChangeRFQ2"
          @onAddNew="handleNew"
        ></tools-panel>
      </template>
      <template v-slot:content>
        <editor
          :config="{id: editorID, api: 'RFQ2s/GetAllDynamic'}"
          @change-data="handlerChangeEditorData"
        />
      </template>
    </layout>
  </page-wrap>
</template>

<script>
import { ServiceRFQ2s } from '@/services/RFQ2s'
export default {
  name: 'SupplierQuotesRFQ2Index',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'tools-panel': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './ToolsPanel'),
    'editor': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './Editor/Index')
  },
  created () {
    this.$bus.$on(`Call-Grid-Create-${this.editorID}`, this.requestCreateData)
    this.$bus.$on(`Call-Grid-Patch-${this.editorID}`, this.requestPatchData)
  },
  beforeDestroy () {
    this.$bus.$off(`Call-Grid-Patch-${this.editorID}`, this.requestPatchData)
    this.$bus.$off(`Call-Grid-Create-${this.editorID}`, this.requestCreateData)
  },
  data () {
    return {
      rfq2ID: null,
      editorID: 'supplier-quotes-rfq2-chosen-false'
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  },
  methods: {
    handlerChangeEditorData (data) {
      let rfq2ID = Number(data.id)
      this.rfq2ID = isNaN(rfq2ID) ? null : rfq2ID
    },
    handlerChangeRFQ2 () {
      if (this.rfq2ID) {
        this.editRFQ()
      } else {
        this.closeRFQ()
      }
    },
    editRFQ () {
      let query = Object.assign({}, this.$route.query, { [this.editorID]: `edit[${this.rfq2ID}]` })
      this.$router.replace({ ...this.$router.currentRoute, query })
    },
    closeRFQ () {
      let query = Object.assign({}, this.$route.query)
      delete query[this.editorID]
      this.$router.replace({ ...this.$router.currentRoute, query })
    },
    handleNew () {
      this.rfq2ID = null
      this.$router.replace({ query: Object.assign({}, this.$route.query, { [this.editorID]: 'new' }) })
    },
    requestCreateData (data, Callback) {
      ServiceRFQ2s.post(data)
        .then(response => {
          this.rfq2ID = response.data.id
          this.editRFQ()
          return response
        })
        .then(response => (Callback) ? Callback(response) : response)
        .catch((e) => {
          this.requestErrorHandler(e, this.L10n('error-create-item'))
          if (Callback) Callback('Error')
        })
    },
    requestPatchData (Data, Callback) {
      ServiceRFQ2s.patch(Data)
        .then(response => (Callback) ? Callback(response) : response)
        .then(response => this.editRFQ)
        .catch(err => {
          this.requestErrorHandler(err, this.L10n('error-update-item'))
          if (Callback) Callback('Error')
        })
    }
  }
}
</script>
